import React, { useState, useEffect } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import GroupsView from '../GroupsView/GroupsView'
import { faTimes, faRightFromBracket, faRightToBracket } from '@fortawesome/free-solid-svg-icons';
import { useGoogleLogin } from '@react-oauth/google';

const UserView = ({ setPage, setUserGUID, userGUID, setUserSelections, getSchedule, setJson, setSelectedGroupGUID, online }) => {

    const login = useGoogleLogin({
        flow: 'auth-code',
        scope: 'openid email profile',
        ux_mode: 'popup', // or 'redirect'
        onSuccess: async ({ code, code_verifier }) => {
            await fetch('/app/login', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ code, codeVerifier: code_verifier, redirectUri: 'postmessage' })
            })
                .then(async (response) => {
                    if (response.ok) {
                        const data = await response.json();
                        if (data.user && data.user.userGUID) {
                            localStorage.removeItem('savedSelections');
                            setUserGUID(data.user.userGUID);
                            localStorage.setItem('userGUID', data.user.userGUID);
                            // setPage('calendar');
                        }
                    } else {
                        return null;
                    }
                })
                .catch((error) => {
                });
        },
        onError: err => console.error(err),
    });

    const logout = () => {
        setUserGUID(null);
        setUserSelections(localStorage.getItem('savedSelections-null') ? JSON.parse(localStorage.getItem('savedSelections-null')) : { user: null, selections: [] });
        setJson(localStorage.getItem(`json-null`) ? JSON.parse(localStorage.getItem(`json-null`)) : null);
        setPage('calendar');
        localStorage.removeItem('userGUID');
        localStorage.removeItem('personalLinkType');
        localStorage.removeItem('personalUrl');
    }

    const closeOptionsView = () => {
        setPage('calendar');
    }

    return (
        <div className="modal" style={{
            position: 'fixed',
            overflow: 'hidden',
            height: '100vh'
        }}>
            <div className="button-container">

                {userGUID ?
                    <button onClick={logout} className="btn btn-black" style={{ flex: '1 1', marginLeft: 0, marginRight: 0 }}>
                        <FontAwesomeIcon icon={faRightFromBracket} /> Logout
                    </button>
                    :
                    <button onClick={login} disabled={!online} className="btn btn-black" style={{ flex: '1 1', marginLeft: 0, marginRight: 0 }}>
                        <FontAwesomeIcon icon={faRightToBracket} /> Login
                    </button>
                }

                <button
                    onClick={closeOptionsView}
                    style={{ flex: '1 1' }}
                    className="btn">
                    <FontAwesomeIcon icon={faTimes} /> Close
                </button>
            </div>
            <div id="groupsViewContainer">
                {userGUID ?
                    <GroupsView
                        userGUID={userGUID}
                        setSelectedGroupGUIDParent={setSelectedGroupGUID}
                        getSchedule={getSchedule}
                    />
                    :
                    <h4 >Login with a Google Account<br /> to access Group Sharing</h4>
                }
            </div>

        </div>
    )
}

export default UserView;